/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from '../../../store/models';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models';
import { DocumentReader } from '../../../store/models';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

@Component({
    selector: 'app-boolean-field',
    templateUrl: './boolean-field.component.html',
    styleUrls: ['./boolean-field.component.scss'],
    standalone: false
})
export class BooleanFieldComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  isReadOnly: boolean;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;

  booleanValue: any;
  showFieldAsEdit: boolean = false;

  get value(): any {
    return this.booleanValue;
  }
  set value(val: any) {
    this.booleanValue = val;
  }

  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  constructor() {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  isActiveClick(): void {
    this.value = !this.value;

    this.onValueChanged();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  tpOnContentUpdated(): void {
    let fieldValue = this.reader.getFieldValue(this.field.systemName);

    if (fieldValue == undefined) {
      fieldValue = this.field.settings.defaultValue;
    }

    this.value = fieldValue;

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }
}
